export default {
    title: 'Publish via link',
    feedback: {
        success: 'URL successfully copied to the clipboard',
        error: 'Error when copying the URL to the clipboard'
    },
    action: 'Copy'
}
